import { LNG } from './Services/LanguageService';

export const SMM_GLOBAL_ID = '4a1f407e-ca4c-43e3-8307-ad54f34b1e0a';
export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';
export const MAX_TOP_STATUS_EXPORT = 10000;

export enum DATE_RANGE_MODE {
    CURRENT_DAY = 'currentDay',
    CURRENT_SHIFT = 'currentShift'
}

export const REFRESH_CURRENT_DATA_TIME = 10 * 60 * 1000;
export const MACHINE_STATUS_NAMES_ORDER = [1, 2, 8, 4, 3, 5, 6, 7, 0];
export const POSITION_STATUS_SORT_ORDER = 0;
export const AVERAGE_SERIES_NAME = `LNG.Text('Dashboard.48')`;
export const CURRENT_SERIES_NAME = `LNG.Text('Dashboard.47')`;
export const NO_DATA_IDENTIFIER = `LNG.Text('Dashboard.53')`;

export const RGL_WIDGET_RESIZE = 'widgetResize';
export const RGL_RESTORE_LAYOUT = 'restoreOriginLayout';

export class AppRouting {
    public static Company = '/company';
    public static Plant = '/plant';
    public static Machine = '/machine';
    public static Analytics = '/analytics';
    public static Administration = '/administration';
    public static Recipe = '/recipe';

}

export class ApiURL {
    public static FilterCustomers = '/companies';
    public static FilterRegions = '/filter/regions';
    public static FilterPlants = '/filter/plants';
    public static FilterDepartments = '/filter/departments';
    public static FilterMachines = '/filter/machines';

    public static MeasuresEfficiency = '/measures/efficiency';
    public static MeasuresInterventions = '/measures/interventions';
    public static MeasuresKpis = '/measures/kpis';
    public static MeasuresRecipeKpis = '/measures/recipe-kpis';
    public static MeasuresAverageEfficiency = '/measures/averageefficiency';
    public static MeasuresStatus = '/measures/status';
    public static MeasuresTopStatus = '/measures/top-statuses';
    public static MeasuresPositionStatus = '/measures/status-types/positions';
    public static MeasuresExport = '/measures/export';

    public static Customer = '/companies';
    public static Regions = '/regions';
    public static Plants = '/plants';
    public static Machines = '/machines';
    public static MachineTypes = '/machine-types';
    public static Departments = '/departments';
    public static Schedules = '/schedules';
    public static Recipes = '/recipes';
    public static Subscriptions = '/subscriptions';
    public static RecipeVersions = '/recipe-versions';
    public static RecipeDeployments = '/recipe-deployments';

    public static Users = '/users';

    public static Timezone = '/timezones';
    public static StatusTypes = '/status-types';
    public static Translations = '/translations';
    public static Languages = '/languages';

}
